import React from 'react';
import LoginField from './Fields/LoginField';
import PasswordField from './Fields/PasswordField';
import ClassicLoginButton from './Buttons/ClassicLoginButton';
import SocialLoginGroup from './SocialLoginGroup';

function LoginForm() {
  return (
    <form className="theme-form">
      <LoginField />
      <PasswordField />
      <ClassicLoginButton />
      {/* <div className="login-divider" /> */}
      {/* <SocialLoginGroup /> */}
    </form>
  );
}

LoginForm.propTypes = {};

export default LoginForm;
